import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queries } from '@/queries';
import { patchSettings } from '@/services/settings';

type UseSettingsProps = {
  onSuccess?: (data?: Awaited<ReturnType<typeof patchSettings>>) => void;
};

export const useSettings = ({ onSuccess }: UseSettingsProps = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: patchSettings,
    mutationKey: queries.settings.mine.queryKey,
    onSuccess: (data) => {
      queryClient.invalidateQueries({
        queryKey: queries.settings.mine.queryKey,
      });

      onSuccess?.(data);
    },
  });
};
